import { Eye, EyeOff } from "lucide-react";
import { useT } from "@/lib/translation";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { usePrivacy } from "@/contexts/PrivacyContext";

export function PrivacyToggle() {
  const t = useT();
  const { isPrivacyMode, setPrivacyMode } = usePrivacy();

  return (
    <ToggleGroup
      type="single"
      value={isPrivacyMode ? "hidden" : "visible"}
      onValueChange={(v) => {
        if (v) setPrivacyMode(v === "hidden");
      }}
      className="gap-1 rounded-lg border p-1"
    >
      <ToggleGroupItem
        value="visible"
        size="sm"
        className="h-8 w-8 p-0"
        title={t("nav:privacyToggle.show")}
      >
        <Eye className="h-4 w-4" />
        <span className="sr-only">{t("nav:privacyToggle.show")}</span>
      </ToggleGroupItem>
      <ToggleGroupItem
        value="hidden"
        size="sm"
        className="h-8 w-8 p-0"
        title={t("nav:privacyToggle.hide")}
      >
        <EyeOff className="h-4 w-4" />
        <span className="sr-only">{t("nav:privacyToggle.hide")}</span>
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
